import styled from "styled-components"
import { Button } from "./"

const Wrapper = styled.ul`
  list-style: none;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
`


export const Tabs = ({
  className,
  activeKey,
  size,
  items,
  onChange,
}:{
  activeKey: string;
  size?: 'normal' | 'small';
  className?: string;
  items: any[];
  onChange?: (tabKey:string) => void;
}) => {
  // console.log(activeKey)
  // console.log(items)
  return (
    <Wrapper>
    { items.map((x:any, index:number) => (
      <Button key={index}
        className={`${(size === 'small') ? 'frame':''}`}
        $size={size || 'normal'}
        $color={
          (x.key === activeKey) ? (
            (size === 'small') ? 'yellow':'charcoal'
          ) : (
            (size === 'small') ? 'charcoal':'stone'
          )
        }
        onClick={() => onChange(x.key)}
      >
        {x.label}
      </Button>
    )) }
    </Wrapper>
  )
}



/**
import type { TabsProps as RcTabsProps } from 'rc-tabs';
import * as React from 'react';
import type { SizeType } from '../config-provider/SizeContext';
import { TabPaneProps } from './TabPane';
export type TabsType = 'line' | 'card' | 'editable-card';
export type TabsPosition = 'top' | 'right' | 'bottom' | 'left';
export { TabPaneProps };
export interface TabsProps extends Omit<RcTabsProps, 'editable'> {
    type?: TabsType;
    size?: SizeType;
    hideAdd?: boolean;
    centered?: boolean;
    addIcon?: React.ReactNode;
    onEdit?: (e: React.MouseEvent | React.KeyboardEvent | string, action: 'add' | 'remove') => void;
    children?: React.ReactNode;
}
declare function Tabs({ type, className, size: propSize, onEdit, hideAdd, centered, addIcon, children, items, animated, ...props }: TabsProps): JSX.Element;
declare namespace Tabs {
    var TabPane: React.FC<TabPaneProps>;
}
export default Tabs;
 */
